import { Stack, Typography, Box } from '@mui/material';
import { StyledIconButton } from "../../../shared/Components/StyledIconButton";
import { FlightingItemDisplay } from './FlightingItemDisplay';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';


interface DivisionBlockProps {
    division: any;
    index: number;
    appTheme: any;
    factor: number;
    editMode: boolean;
    divisionCount: number;
    onAddDivision: () => void;
    onDeleteDivision: (divisionIndex: number) => void;
}

export const DivisionBlock = ({
    division,
    index,
    appTheme,
    factor,
    editMode,
    divisionCount,
    onAddDivision,
    onDeleteDivision,
}: DivisionBlockProps) => {
    const isLastDivision = index === divisionCount - 1;
    const canDelete = divisionCount > 1;

    return (
        <Stack key={`division-${index}`} direction='row' spacing={2} flex={1} alignItems='center'
            sx={{ borderBottom: `1px dotted ${appTheme.palette.divider}`}}>
            <Typography variant='subtitle2' color='primary' 
                sx={{ fontWeight: 500, alignContent: 'center' }}>
                Division:
            </Typography>
            {Object.keys(division).map((key: string) => (
                (key !== 'index' &&
                    <FlightingItemDisplay
                        key={key}
                        index={index}
                        orient='row'
                        label={key.replace('division', '')}
                        keyName={key}
                        level='division'
                        hideLabel={key === 'divisionName' ? true : false}
                    />)
            ))}
            {editMode && (
                <Stack direction='row' sx={{
                    minWidth: 80 * factor,
                    height: 25 * factor,
                    alignContent: 'center',
                    justifyContent: 'center',
                }}>
                    {isLastDivision ? (
                        <StyledIconButton
                            icon={<AddIcon sx={{ fontSize: 14 * factor }} />}
                            label=''
                            appTheme={appTheme}
                            factor={factor * 0.8}
                            color='primary'
                            width={38 * factor}
                            height={'max-content'}
                            onClick={onAddDivision}
                        />
                    ) : (
                        <Box sx={{ minWidth: 38 * factor, height: 25 * factor }} />
                    )}
                    <StyledIconButton
                        appTheme={appTheme}
                        factor={factor}
                        label=''
                        color='error'
                        icon={<DeleteIcon sx={{ fontSize: 16 * factor }} />}
                        disabled={!canDelete}
                        width={30 * factor}
                        height={25 * factor}
                        onClick={() => onDeleteDivision(division.index)}
                    />
                </Stack>
            )}
        </Stack>
    )
}
